module.exports = __webpack_public_path__ + "static/goats-eac087354e709ff35dc10c5db45a824f.svg";